export default __webpack_public_path__ + "static/media/Appstore.a400c6fe.svg";